import React, { Component } from "react";
import AuthService from '../../../services/login/auth.service';
import history from "./history";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import MensajeUsuario from "../../generico/MensajeUsuario";
import Titulo from "../../generico/TituloPagina";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faLock} from "@fortawesome/free-solid-svg-icons";

export default class PinAcceso extends Component {

    constructor(props) {
        super(props);
        this.handleResetPin = this.handleResetPin.bind(this);
        this.onChangePassNew = this.onChangePassNew.bind(this);
        this.onChangeCedula = this.onChangeCedula.bind(this);
        this.onChangePassTemp = this.onChangePassTemp.bind(this);
        this.onChangePassDupli = this.onChangePassDupli.bind(this);

        this.state = {
            cedula: sessionStorage.getItem("cedula"),
            passTemp: sessionStorage.getItem("temporal"),
            passNew: "",
            passDupli: "",
            loading: false,

            message: ""
        };
    }
    componentDidMount() {


    }
    onChangePassNew(e) {
        this.setState({
            passNew: e.target.value
        });
    }

    onChangeCedula(e) {
        this.setState({
            cedula: e.target.value
        });
    }

    onChangePassTemp(e) {
        this.setState({
            passTemp: e.target.value
        });
    }
    onChangePassDupli(e) {
        this.setState({
            passDupli: e.target.value
        });
    }



    handleResetPin(e) {

        var passw = document.getElementById('pass').value;
        var passwReingreso = document.getElementById('passReingreso').value;
        var msg = "";


        e.preventDefault();
        if (!/[A-Z]/.test(passw)) {
            msg = "Debe ingresar al menos una letra mayúscula"
            this.setState({
                message: msg,
                loading: false
            });
            return
        }

        if (!/[0-9]/.test(passw)) {
            msg = "Debe ingresar al menos un número"
            this.setState({
                message: msg,
                loading: false
            });
            return
        }

        if (passwReingreso!==passw) {
            msg = "La clave nueva no coincide con la clave de verificación"
            this.setState({
                message: msg,
                loading: false
            });
            return
        }

        /*var regularExpression = /^[a-zA-Z0-9!@#$%^&*]{6,16}$/;
        if (!regularExpression.test(passw)) {
            msg = "Debe tener al menos un caracter especial"
            this.setState({
                message: msg,
                loading: false
            });
            return
        }*/
        this.setState({
            message: msg,
            loading: false
        });

        this.form.validateAll();

        if (this.checkBtn.context._errors.length === 0) {

            AuthService.resetPin(this.state.cedula, this.state.passNew, this.state.passTemp).then(
                (response) => {
                    var jsonData = JSON.parse(response);
                    if (jsonData.codigo === '0') {
                        sessionStorage.setItem("cambio", "N");
                        sessionStorage.setItem("reset", 'S');
                        history.push('/login')
                        window.location.reload();
                    } else {

                        const resMessage = jsonData.mensaje;

                        this.setState({
                            loading: false,
                            message: resMessage
                        });


                    }

                },
                error => {
                    const resMessage = error.response.data;

                    this.setState({
                        loading: false,
                        message: resMessage
                    });
                }
            );
        } else {
            this.setState({
                loading: false
            });
        }
    }

    render(props) {
        return (
            <div className="content-wrapper">
                <br />
                <section className="content">
                    <div className="container">
                        <div className="row light .importante" style={{ padding: '2em 0', backgroundColor:'#fff'}}>
                            <div className="col-md-12">
                                <MensajeUsuario tipo="INFO"
                                    titulo="Importante!"
                                    mensaje="Debe cambiar su clave de acceso" />
                            </div>
                        </div>
                        <div className="row justify-content-md-center" >
                            
                                <div className="card">
                                    
                                    <Titulo texto="Cambiar Clave de Acceso" />

                                    
                                    <div className="card-body pad table-responsive">
                                        <div className="row">
                                            <div className="col-lg-7 col-12">
                                                <div className="callout callout-warning consideraciones">
                                                    <h5>Consideraciones</h5>
                                                    <p>Para habilitar este servicio debe acudir a Casa Matriz o a una de las sucursales de la Cooperativa, el mismo es sin costo.
                                                    Recuerde que la Clave es exclusivamente para su uso personal, y que la misma sustituye a su firma, siendo de su entera responsabilidad el uso de la misma. No la divulgue.
                                                    Tenga presente que la <strong> Universitaria Ltda.</strong> nunca solicitará vía telefónica o por email datos personales, número de cuenta, número de tarjeta de crédito, contraseñas o cualquier otra información confidencial.
                                                    Proteja la información de sus cuentas, una vez que haya finalizado sus operaciones, cierre el navegador.</p>
                                                </div>
                                            </div>
                                            <div className="col-lg-5 col-12">
                                                <div className="card-body login-card-body">
                                                    <Form onSubmit={this.handleResetPin} ref={c => { this.form = c; }}>

                                                        <div className="form-group">
                                                            <label className="input-label-bold">Cédula de identidad</label>
                                                            <input disabled type="text" className="input-box form-control" name="cedula" value={this.state.cedula} />
                                                        </div>

                                                        <div className="form-group">
                                                            <label className="input-label-bold">Clave Temporal</label>
                                                            <input disabled type="password" className="input-box form-control" name="passTemp" value={this.state.passTemp} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="input-label-bold">Clave Nueva</label>
                                                            <input id="pass" type="password" className="input-box form-control" name="passNew" value={this.state.passNew} onChange={this.onChangePassNew}
                                                                minLength={8} maxLength={20} required />
                                                        </div>

                                                        <div className="form-group">
                                                            <label className="input-label-bold">Reingrese Clave Nueva</label>
                                                            <input type="password" id="passReingreso" className="input-box form-control" name="passNew" value={this.state.passDupli}
                                                                onChange={this.onChangePassDupli} required />
                                                        </div>
                                                        <hr />
                                                        <div className="form-group">
                                                            <button className="btn btn-cu-primary btn-block" disabled={this.state.loading}>
                                                                {this.state.loading && (
                                                                    <span className="spinner-border spinner-border-sm"></span>
                                                                )}
                                                                <FontAwesomeIcon icon={faLock} />  Cambiar
                                                            </button>
                                                        </div>

                                                        {this.state.message && (
                                                            <div className="form-group">
                                                                <div className="alert alert-danger" role="alert">
                                                                    {this.state.message}
                                                                </div>
                                                            </div>
                                                        )}
                                                        <CheckButton style={{ display: "none" }} ref={c => { this.checkBtn = c; }} />
                                                    </Form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            
                        </div>
                    </div>
                </section>
            </div>

        );
    }
}